const { apiFetch } = wp;

const subscriberApi = {
  /**
   * Fetch subscriber details.
   *
   * @param {String} email Subscriber email
   * @returns {Promise}
   */
  fetchSubscriber(email) {
    return apiFetch({
      path: `/nbc/v1/subscriber/${email}?t=${Date.now()}`,
    });
  },
  /**
   * Update subscriber details.
   *
   * @param {Object} formData The form data.
   * @param {String} nonce WordPress nonce.
   * @returns {Promise}
   */
  updateSubscriber(formData, nonce) {
    return apiFetch({
      path: '/nbc/v1/subscriber/update/',
      method: 'POST',
      data: formData,
      headers: { 'X-WP-Nonce': nonce },
    });
  },
};

export default subscriberApi;
